import { ViewMode } from './view-mode';

export interface HashParams {
  profileURL?: string;
  title?: string;
  localProfilePath?: string;
  viewMode?: ViewMode;
}

function getViewMode(value: string): ViewMode | null {
  switch (value) {
    case 'time-ordered':
      return ViewMode.CHRONO_FLAME_CHART;
    case 'left-heavy':
      return ViewMode.LEFT_HEAVY_FLAME_GRAPH;
    case 'sandwich':
      return ViewMode.SANDWICH_VIEW;
    default:
      return null;
  }
}

export function getHashParams(hashContents = window.location.hash): HashParams {
  try {
    if (!hashContents.startsWith('#')) {
      return {};
    }
    const components = hashContents.substr(1).split('&');
    const result: HashParams = {};
    for (const component of components) {
      let [key, value] = component.split('=');
      value = decodeURIComponent(value);
      if (key === 'profileURL') {
        result.profileURL = value;
      } else if (key === 'title') {
        result.title = value;
      } else if (key === 'localProfilePath') {
        result.localProfilePath = value;
      } else if (key === 'view') {
        const mode = getViewMode(value);
        if (mode !== null) {
          result.viewMode = mode;
        } else {
          console.error(`Ignoring invalid view specifier: ${value}`);
        }
      }
    }
    return result;
  } catch (e) {
    console.error(`Error when loading hash fragment.`);
    console.error(e);
    return {};
  }
}
